
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-else.json") })
        }
      }, "path---tags-else");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---tags-else!./.cache/json/tags-else.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---tags-else!./.cache/json/tags-else.json
// module chunks = 45